import { Component, effect, inject } from '@angular/core';
import {
  ActiveUserState,
  ActiveUserStore,
} from '../../../stores/user/active-user.state';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Message } from 'primeng/api';
import { getState, patchState } from '@ngrx/signals';
import { CardModule } from 'primeng/card';
import { Button } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { NgIf } from '@angular/common';
import { AlertComponent } from '../../atoms/alert/alert.component';
import { DividerModule } from 'primeng/divider';
import { Router } from '@angular/router';
import { InputOtpModule } from 'primeng/inputotp';
import { FormFieldWrapperComponent } from '../form-field-wrapper/form-field-wrapper.component';
import { HeaderComponent } from '../../atoms/header/header.component';

@Component({
  selector: 'app-two-factor-form',
  standalone: true,
  imports: [
    CardModule,
    ReactiveFormsModule,
    Button,
    InputTextModule,
    NgIf,
    AlertComponent,
    DividerModule,
    InputOtpModule,
    FormFieldWrapperComponent,
    HeaderComponent,
  ],
  templateUrl: './two-factor-form.component.html',
  styleUrl: './two-factor-form.component.scss',
})
export class TwoFactorFormComponent {
  readonly store = inject(ActiveUserStore);
  private router = inject(Router);

  twoFactorForm: FormGroup;
  submitted = false;
  pwMasked = true;

  error: Message = {
    severity: 'error',
    summary: 'Verifizierung fehlgeschlagen',
    detail: 'Der eingegebene Code ist ungültig oder abgelaufen.',
  };

  constructor(private formBuilder: FormBuilder) {
    this.twoFactorForm = this.formBuilder.group({
      code: ['', [Validators.required, Validators.pattern('^[0-9]{6}$')]],
    });
  }

  onSubmit(): void {
    this.submitted = true;
    const code = this.twoFactorForm.value.code;
    const userId = this.store.tempUserId();

    console.log('Submitting 2FA code:', code, 'for user:', userId);

    if (this.twoFactorForm.invalid) {
      return;
    }

    if (userId) {
      this.store.verify2FA({ userId, code });
    } else {
      console.error('No tempUserId found in store!');
    }
  }

  cancel(): void {
    patchState(this.store, {
      twoFactorRequired: false,
      tempUserId: null,
      error: null,
    });
    this.router.navigate(['/login']);
  }
}
